import {
  CURRENT_COMPANY_ID_HEADER_KEY,
  SILENT_REQUEST_HEADER_KEY,
} from "@hd/http-client/constants";
import httpClient from "@hd/http-client/http-client";
import { CommunicationTypeEnum } from "@hd/types/dto/communication/communication-type.enum";
import { ScheduledCommunication } from "@hd/types/dto/communication/scheduled-communication.dto";
import { PagedResultDto } from "@hd/types/dto/shared/paged-result.dto";
import { useInfiniteQuery } from "@tanstack/react-query";

type QueryParams = {
  companyId: number | null;
  communicationType: CommunicationTypeEnum[];
};

const PAGE_SIZE = 20;

const apiUrl = "/communication/get-scheduled-communications-paged";

const fetchData = async (
  params: QueryParams & { skip: number },
): Promise<PagedResultDto<ScheduledCommunication>> => {
  const result = await httpClient.post<PagedResultDto<ScheduledCommunication>>(
    import.meta.env.VITE_HD_API_URL + apiUrl,
    {
      communicationType: params.communicationType,
      take: PAGE_SIZE,
    },
    {
      headers: {
        [CURRENT_COMPANY_ID_HEADER_KEY]: params.companyId,
        [SILENT_REQUEST_HEADER_KEY]: true,
      },
    },
  );

  return result.data;
};

export const scheduledCommunicationsQueryKey = (params: QueryParams) => [
  "scheduledCommunications",
  params,
];

export const useScheduledCommunicationsQuery = (params: QueryParams) => {
  return useInfiniteQuery({
    enabled: !!params.companyId,
    // staleTime: 10000 * 60,
    queryKey: scheduledCommunicationsQueryKey(params),
    queryFn: ({ pageParam }) => fetchData(pageParam),
    // placeholderData: keepPreviousData,
    initialPageParam: { ...params, skip: 0 },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.items.length === 0 || lastPage.items.length < PAGE_SIZE) {
        return undefined;
      }
      return {
        ...lastPageParam,
        skip: lastPageParam.skip + PAGE_SIZE,
      };
    },
  });
};
